{
  function funnel() {
    'ngInject';

    const directive = {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/funnel/funnel.html',
      scope: {
        stats: '='
      }
    };
    return directive;
  }

  angular.module('pims').directive('funnel', funnel);
}